import { User } from "./user.types";

export interface LeaveDto {
  id: number;
  type: LeaveType;
  startDate: string; // ISO formatında datetime
  endDate: string; // ISO formatında datetime
  startTime?: string | null; // Saatlik izin için opsiyonel
  endTime?: string | null; // Saatlik izin için opsiyonel
  reason: string;
  status: LeaveStatus;
  documentUrl?: string | null;
  approvedBy?: User | null;
  rejectedBy?: User | null;
  createdAt?: string;
  updatedAt?: string;
  user?: User;
  processedBy?: User | null;

  // Hiyerarşi ile ilgili alanlar
  currentStep?: number;
  approvalHistory?: {
    step: number;
    approverId: number;
    approverName: string;
    decision: 'approved' | 'rejected';
    decisionDate: string;
    notes?: string;
  }[];
  approvalFlow?: {
    currentStep: number;
    steps: {
      stepOrder: number;
      approver: {
        id: number;
        firstName: string;
        lastName: string;
      };
      status: 'approved' | 'rejected' | 'pending_approval' | 'pending';
      decisionDate: string | null;
    }[];
  } | null;
}

export interface LeaveResponse {
  approved: LeaveDto[];
  rejected: LeaveDto[];
  pending: LeaveDto[];
  totalLeaveCount: number;
  approvedCount: number;
  rejectedCount: number;
  pendingCount: number;
}

export interface LeaveCreateResponse {
  id: number;
  segmentedByWorkingDays: boolean;
  leaves: Array<{
    id: number;
    startDate: string;
    endDate: string;
  }>;
}

export interface LeaveAdminUpdateDTO {
  status: LeaveStatus;
}

export interface LeaveAdminFullUpdateDTO {
  type?: LeaveType;
  startDate?: string;
  endDate?: string;
  startTime?: string | null;
  endTime?: string | null;
  documentUrl?: string | null;
}

export interface LeaveCreateDTO extends Omit<LeaveDto, "id" | "status"> {
  employeeId: number;
}

export interface LeaveUserCreateDTO {
  type: LeaveType;
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  reason: string;
  documentUrl?: string;
}

export interface LeaveUserUpdateDTO extends LeaveUserCreateDTO {
  id: number;
}

export interface UserYearlyLeaveSummary {
  totalAnnualLeaveLimit: number;
  usedAnnualLeaveDays: number;
  remainingAnnualLeaveDays: number;
  approvedMedicalLeaves: number;
  totalLeaveRequests: number;
}

export enum LeaveType {
  ANNUAL = "annual",
  HOURLY = "hourly",
  MEDICAL = "medical",
  MARRIAGE = "marriage",
  BIRTH = "birth",
  UNPAID = "unpaid",
  SPECIAL = "special",
  PATERNITY = "paternity",
  DEATH = "death",
}

export enum LeaveStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  PENDING_HIERARCHY_APPROVAL = "pending_hierarchy_approval",
}

export interface LeaveStats {
  total: number;
  approved: number;
  pending: number;
  rejected: number;
}

export interface LeaveLimits {
  annual: number;
  hourly: number;
  medical: number;
  marriage: number;
  birth: number;
  unpaid: number;
  paternity: number;
  death: number;
  special: number;
}

export interface UpdateLeaveLimitsDTO {
  leaveLimits: Partial<LeaveLimits>;
}
